<template>
    <div>
        <div class="page-content-ptb">
            <div class="orderRecord-tabWrap">
                <div class="orderRecord-tab js-tab" :class="{ active: status == 'all'}"  @click="status='all'"
                data-el="orderRecord1" data-box="orderRecord-wrap">
                    <div class="orderRecord-tab-box">全部订单</div>
                </div>
                <div class="orderRecord-tab js-tab" :class="{ active: status == 'noPaid'}" @click="status='noPaid'"
                data-el="orderRecord2" data-box="orderRecord-wrap">
                    <div class="orderRecord-tab-box">
                        待付款订单
                        <p class="orderRecord-tab-badge" v-show="pageData.noPaid.length > 0">{{pageData.noPaid.length}}</p>
                    </div>
                </div>
                <div class="orderRecord-tab js-tab" :class="{ active: status == 'paid'}" @click="status='paid'"
                data-el="orderRecord3" data-box="orderRecord-wrap">
                    <div class="orderRecord-tab-box">已付款订单</div>
                </div>
            </div>
            <div class="orderRecord-wrap">
                <div class="tab-cell" id="orderRecord1">
                    <div class="no_booking_tips" v-show="isFinishLoading && pageData[status].length == 0">您还没有相关订单哦</div>
                    <BookingListItem
                        v-for="(order, i) in pageData[status]"
                        :key="i"
                        :order="order"
                        :selectedBooking="selectedBooking"
                        :selectedOpenBooking="selectedOpenBooking"
                        :onBookingSelected="onBookingSelected"
                        :onOpenBookingSelected="onOpenBookingSelected"
                        :onQiaohuRoomClicked="showQiaohuPopup"
                        :onStarrySkyClicked="showStarrySkyPopup"
                        :onConnectRoomClicked="showConnectRoomPopup"
                        :orderItem="order"
                    />
                </div>
            </div>
        </div>

        <BookingListBottom
            v-show="isShowBottomBar"
            :selectedBooking="selectedBooking"
            :selectedOpenBooking="selectedOpenBooking"
        />

        <QiaohuPopup
            :shipCode="targetShipCode"
            :sailDate="targetSailDate"
            :onGoBack="closeQiaohuPopup"
            :isShow="isShowQiaohuPopup"
        />

        <StarrySkyPopup
            :shipCode="targetShipCode"
            :sailDate="targetSailDate"
            :onGoBack="closeStarrySkyPopup"
            :isShow="isShowStarrySkyPopup"
        />

        <ConnectRoomPopup
            :onGoBack="closeConnectRoomPopup"
            :isShow="isShowConnectRoomPopup"
        />
    </div>
</template>

<script>
import api from '@/api'
import bookingStatusHelper from '@/utilities/bookingStatusHelper'
import StarrySkyPopup from "@/components/Cruise/StarrySkyPopup.vue";
const BookingListItem = () => import('@/components/Booking/BookingListItem.vue')
const BookingListBottom = () => import('@/components/Booking/BookingListBottom.vue')
const QiaohuPopup = () => import('@/components/Cruise/QiaohuPopup')
const ConnectRoomPopup = () => import('@/components/Cruise/ConnectRoomPopup')
export default {
    name: 'BookingList',
    components: {
      StarrySkyPopup,
        BookingListItem,
        QiaohuPopup,
        ConnectRoomPopup,
        BookingListBottom
    },
    beforeMount() {
        this.$store.commit('SET_PAGE_TITLE', '订单页')
        const query = this.$router.currentRoute.query
        if (query && query.sort == 2) {
            this.status = 'noPaid'
        } else if (query && query.sort == 3) {
            this.status = 'paid'
        }

        this.initPage()
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: true})
        window.onpopstate = () => {
            if (this.isShowQiaohuPopup) {
                this.closeQiaohuPopup()
            }
            if (this.isShowStarrySkyPopup) {
              this.closeStarrySkyPopup()
            }
            if (this.isShowConnectRoomPopup) {
                this.closeConnectRoomPopup()
            }
        }
    },
    beforeDestroy () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
        window.onpopstate = () => {}
    },
    data () {
        return {
            pageData: {
                all: [],
                noPaid: [],
                paid: []
            },
            selectedBooking: [],
            selectedOpenBooking: [],
            targetShipCode: '',
            targetSailDate: '',
            status: 'all',
            isFinishLoading: false,
            isShowQiaohuPopup: false,
            isShowStarrySkyPopup: false,
            isShowConnectRoomPopup: false
        }
    },
    methods: {
        async initPage () {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                return this.$router.push({ name: 'Login', query:{
                    returnUrl: encodeURIComponent(location.href)
                }})
            }
            const storedBookingList = this.$store.state.booking.bookingList
            if (storedBookingList) {
                this.getBookingListSuccessHandler(storedBookingList)
                this.isFinishLoading = true
            } else {
                this.$loading.show()
                const { success, data, errMsg } = await api.booking.bookingList({})
                this.$loading.hide()
                if (!success) {
                    this.$alert.show(errMsg)
                    return
                }
                if (data && data.userCenterBookings) {
                    this.getBookingListSuccessHandler(data.userCenterBookings)
                    this.$store.commit('SET_BOOKING_LIST', data.userCenterBookings)
                    this.isFinishLoading = true
                }
            }
        },
        getBookingListSuccessHandler (bookingList) {
            this.pageData = {
                all: this.getBookingsByStatus('all', bookingList),
                noPaid: this.getBookingsByStatus('noPaid', bookingList),
                paid: this.getBookingsByStatus('paid', bookingList)
            }
        },
        // 根据状态获取订单
        // staus: all, noPaid, paid
        getBookingsByStatus(status, bookingList) {
            if (status == 'all') {
                return bookingList
            } else {
                this.$loading.show()
                let statusList = []
                if (status == 'noPaid') {
                    statusList = ['unpaid', 'unpaidFull']
                } else if (status == 'paid') {
                    statusList = ['paid', 'hasComment', 'noComment', 'confirmed']
                }

                let result = []
                const curDate = new Date()
                bookingList.forEach((order)=> {
                    if (order.bookingItems) {
                        let items = []
                        order.bookingItems.forEach((booking) => {
                            const bookingStatus = bookingStatusHelper.getBookingStatus(booking)
                            if (statusList.indexOf(bookingStatus) >= 0) {
                                if (bookingStatus == 'unpaid' || bookingStatus == 'unpaidFull') {
                                    const sailDate = new Date(booking.sailDate)
                                    const openBookingEndDate = new Date(booking.openBookingEndDate)
                                    if (((booking.openBookingOrderId && booking.openBookingOrderId.length > 0 && openBookingEndDate > curDate)
                                    || sailDate > curDate)) {
                                        items.push(booking)
                                    }
                                } else {
                                    items.push(booking)
                                }
                            }
                        })
                        if (items.length > 0) {
                            result.push({
                                shoppingCartOrderId: order.shoppingCartOrderId,
                                createdDate: order.createdDate,
                                bookingItems: items
                            })
                        }
                    }
                })
                this.$loading.hide()
                return result
            }
        },
        onBookingSelected (booking) {
            if (this.selectedBooking.some(r=>r.bookingRecordId == booking.bookingRecordId)) {
                // 反选
                this.selectedBooking = this.selectedBooking.filter(r=>r.bookingRecordId != booking.bookingRecordId)
            } else {
                const status = bookingStatusHelper.getBookingStatus(booking)
                if (status == 'unpaid' || status == 'unpaidFull') {
                    this.selectedBooking.push(booking)
                    this.selectedOpenBooking = []
                }
            }
        },
        onOpenBookingSelected (booking) {
            // opbk目前只支持单选，不支持多选
            if (this.selectedOpenBooking.length > 0
                && this.selectedOpenBooking[0].openBookingOrderId == booking.openBookingOrderId) {
                this.selectedOpenBooking = []
            } else {
                this.selectedOpenBooking = [booking]
            }
            this.selectedBooking = []
        },
        showQiaohuPopup (booking) {
            this.targetShipCode= booking.shipCode
            let sailDate = booking.sailDate
            if (sailDate.length > 10) {
                sailDate = sailDate.substring(0, 10)
            }
            this.targetSailDate = sailDate
            this.isShowQiaohuPopup = true
            this.showPopup()
        },
        closeQiaohuPopup () {
            this.isShowQiaohuPopup = false
        },
        showStarrySkyPopup(booking) {
          this.targetShipCode= booking.shipCode
          let sailDate = booking.sailDate
          if (sailDate.length > 10) {
            sailDate = sailDate.substring(0, 10)
          }
          this.targetSailDate = sailDate
          this.isShowStarrySkyPopup = true;
        },
        closeStarrySkyPopup() {
          this.isShowStarrySkyPopup = false;
        },
        showConnectRoomPopup () {
            this.isShowConnectRoomPopup = true
            this.showPopup()
        },
        closeConnectRoomPopup () {
            this.isShowConnectRoomPopup = false
        },
        showPopup() {
            history.pushState({ page: 'bookingList' }, null);
        }

    },
    computed: {
        isShowBottomBar () {
            return (this.selectedBooking.length > 0 || this.selectedOpenBooking.length > 0)
                && (this.status == 'all' || this.status == 'noPaid')
        }
    }
}
</script>

<style lang="less" scoped>

.orderRecord-tabWrap {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    height: 46px;
    margin-bottom: 10px;
    padding: 0 10px;
    -webkit-box-shadow: 0 1px 2px 0 #D6D7D8;
    box-shadow: 0 1px 2px 0 #D6D7D8;
    background-color: #fff;
}

.orderRecord-tab {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 14px;
    line-height: 1;
    color: #666;
}

.orderRecord-tab-box {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 100%;
}

.orderRecord-tab-badge {
    min-width: 16px;
    min-height: 16px;
    margin: 0;
    padding: 2px;
    font-size: 12px;
    line-height: 12px;
    color: #fff;
    text-align: center;
    background-color: #FF5055;
    border-radius: 20px;
}

.orderRecord-tab.active {
    color: #4A90E2;
    font-weight: bold;
}

.orderRecord-tab.active .orderRecord-tab-box::after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #4A90E2;
}

.no_booking_tips {
    text-align: center;
    top: 35vh;
    position: relative;
    font-size: 16px;
}
.QIAOHU_CSS {
    background-size: 100% 100%;
    width: 113px;
}
.ConnectIcon_css {
    background-size: 100% 100%;
    width: 113px;
}
</style>
